import { IconLink } from "../icon/variants/IconLink.js";
import { Flex } from "../mantine-passthroughs/index.js";
import { Anchor } from "../anchor/Anchor.js";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/website/Website.tsx
/**
* A flexible component to display location url information
*/
const Website = ({ iconColor = "primary", showIcon = true, url, "data-testid": testId }) => {
	const urlLabel = url.replace(/^https?:\/\//, "");
	return /* @__PURE__ */ jsxs(Flex, {
		align: "center",
		gap: "xxs",
		"data-testid": testId,
		children: [showIcon && /* @__PURE__ */ jsx(IconLink, { color: iconColor }), /* @__PURE__ */ jsx(Anchor, {
			href: url,
			target: "_blank",
			children: urlLabel
		})]
	});
};

//#endregion
export { Website };